import type { StructuredLogger } from '@mimir/primitive/structuredLogger';
import { MultiArrayBuffer } from './multiArrayBuffer';
import type { MxfDictionary } from './mxfDictionary';
import { Parser } from './parser';
import type { Serializer } from './serializer';

export function parseMxfLocalSets(
  structuredLogger: StructuredLogger,
  parser: Parser,
  dictionary: MxfDictionary,
  callback: (parser: Parser, ul: string, name: string | undefined) => void,
) {
  while (parser.remain() > 0) {
    const localTag = parser.readLocalTag();
    const length = parser.readUInt16BE();
    if (length > parser.remain()) {
      throw new Error(`Invalid length for header entry: ${length}`);
    }
    const ul = dictionary.getUlFromLocalTag(localTag);

    // TODO: Should be able to implement this in a nice way without doing
    // a copy
    const bytes = parser.readUint8Array(length);
    const source  = new MultiArrayBuffer();
    source.push(bytes);

    if (ul === undefined) {
      structuredLogger.log({ level: 'warn', message: `Ignoring unknown local tag: ${localTag}` });
      continue;
    }

    const name = dictionary.getName(ul);

    callback(new Parser(source), ul, name);
  }
}

export class LocalSetsWriter {
  constructor(
    private dictionary: MxfDictionary,
    private serializer: Serializer
  ) { }

  public writeEntry(name: string, callback: (writer: Serializer) => void) {
    const ul = this.dictionary.getUl(name);
    if (ul === undefined) {
      throw new Error(`No such name in dictionary: ${name}`);
    }

    const localTag = this.dictionary.getLocalTagFromUl(ul);
    if (localTag === undefined) {
      throw new Error(`LocalTag for ${ul} (${name}) not found in dictionary. This could mean it is missing from the PrimerPack or the PrimerPack has not parsed`);
    }
    this.serializer.writeLocalTag(localTag);
    this.serializer.writeWithSizePrefixUInt16BE(callback);
  }
}
